// Informacion de usuario (contexto)

import { createContext, useContext, useState, useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const UserContext = createContext();

export function UserProvider({ children }) {
  const [user, setUser] = useState(null);

  // theme-based responsive detection (MUI standard way)
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const normalizeRole = (role) => {
    if (!role) return null;
    if (typeof role === 'string') return role.trim().toUpperCase();
    if (typeof role === 'object' && role.name) return String(role.name).trim().toUpperCase();
    return String(role).trim().toUpperCase();
  };

  // role helper (kept stable outside memo)
  const hasRole = (roles) => {
    // console.log("roles:", roles, "user role:", user?.role);
    const normalizedUserRole = normalizeRole(user?.role);
    // console.log("normalized user role:", normalizedUserRole);
    if (!normalizedUserRole) return false;
    const roleArray = Array.isArray(roles) ? roles : [roles];
    return roleArray.map(normalizeRole).includes(normalizedUserRole);
  };

  // context value (must include ALL dependencies used in UI)
  const value = useMemo(() => ({
    user,
    setUser,
    hasRole,
    isMobile
  }), [user, isMobile]);

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  return useContext(UserContext);
}